export const USER_JOURNEY_NAMES = {
  CHECKOUT: 'afterpay-checkout',
} as const

export type UserJourneyName = (typeof USER_JOURNEY_NAMES)[keyof typeof USER_JOURNEY_NAMES]

export const USER_JOURNEY_EVENTS = {
  STARTED: 'uj.journey.started',
  COMPLETED: 'uj.journey.completed',
} as const

/** application_name in the RecordCompletedJourney contract — distinguishes us from "cash-web"/"square" */
export const USER_JOURNEY_APPLICATION_NAME = 'afterpay-web'
export const USER_JOURNEY_PLATFORM_NAME = 'web'

/** The canonical mobile UJ framework default — journeys idle this long end TERMINATED/TIMEOUT_* */
export const USER_JOURNEY_TIMEOUT_MS = 10 * 60 * 1000

/**
 * A timeout callback firing this far past its anchored deadline means the timer was
 * throttled/frozen (hidden/backgrounded tab) — classify the user as idle at the deadline
 * regardless of what `document.visibilityState` reads by the time it runs
 */
export const USER_JOURNEY_TIMEOUT_LATE_FIRE_GRACE_MS = 5 * 1000

/** Signals recorded by the identity-verification anchors (CASHDAP-3422) — friction: an expected detour, never SLI-BAD */
export const IDENTITY_VERIFICATION_SIGNALS = {
  /** startCheckout rejected with an IDV-eligible code — the journey continues through the verify flow */
  REQUIRED: 'identity-verification-required',
} as const

/** Signals recorded by the Cash-cohort ($Pay) anchors (CASHDAP-3409) — both friction: expected customer outcomes, never SLI-BAD */
export const CASH_AUTH_SIGNALS = {
  /** The customer actively declined the grant in the Cash ceremony */
  DECLINED: 'cash-authorization-declined',
  /** The customer never completed the grant before the cash-auth polling limit */
  TIMEOUT: 'cash-authorization-timeout',
} as const
